import { MAX_CUSTOM_PRODUCT_NUMBER_INPUT_LENGTH } from "variables";

export const allowOnlyNumberKeys = (e) => {
  if (["e", "E", "+", "-"].includes(e.key)) {
    e.preventDefault();
  }
};

export const limitNumberInputLength = (e) => {
  if (e.target.value.length > MAX_CUSTOM_PRODUCT_NUMBER_INPUT_LENGTH) {
    e.target.value = e.target.value.slice(
      0,
      MAX_CUSTOM_PRODUCT_NUMBER_INPUT_LENGTH,
    );
  }
};

export const handleNumberPaste = (e) => {
  const pasted = e.clipboardData.getData("text");
  if (
    !/^[0-9.]+$/.test(pasted) ||
    pasted.length > MAX_CUSTOM_PRODUCT_NUMBER_INPUT_LENGTH
  ) {
    e.preventDefault();
  }
};
